<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">登录日志</span></div>
		<div class="margin-top margin-left margin-right" style="display: flex;">
			<input type="text" v-model="mobile" placeholder="输入手机号搜索" style="width: 160px;"
				   @keyup.enter="doSearch"/>
			<Select v-model="status" :datas="statusOptions" placeholder="登录结果" style="width: 120px; margin-left: 8px;"
					@change="doSearch"/>
			<Button color="primary" :loading="loading" @click="doSearch">搜索</Button>
		</div>
		<div class="h-panel-body">
			<Table :datas="dataList" :loading="loading">
				<TableItem prop="id" title="ID" :width="70"/>
				<TableItem prop="mobile" title="手机号" :width="130"/>
				<TableItem prop="nickname" title="昵称" :width="120"/>
				<TableItem prop="ip" title="IP" :width="120"/>
				<TableItem prop="loginType" title="登录方式" :width="90" align="center"/>
				<TableItem title="结果" :width="80" align="center">
					<template slot-scope="{data}">
						<span :style="{color: data.status === 1 ? '#27ae60' : '#e74c3c'}">
							{{ data.status === 1 ? '成功' : '失败' }}
						</span>
					</template>
				</TableItem>
				<TableItem prop="failReason" title="失败原因"/>
				<TableItem title="时间" :width="150">
					<template slot-scope="{data}">
						{{ data.createDate ? moment(data.createDate).format('YYYY-MM-DD HH:mm') : '' }}
					</template>
				</TableItem>
			</Table>
			<Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
						@change="loadList" small align="right"/>
		</div>
	</app-content>
</template>

<script>
	import moment from 'moment';

	export default {
		name: "AdminLoginLogs",
		data() {
			return {
				loading: false,
				mobile: '',
				status: null,
				statusOptions: [
					{key: null, title: '全部'},
					{key: 1, title: '成功'},
					{key: 0, title: '失败'}
				],
				dataList: [],
				pagination: {
					page: 1,
					size: 20,
					total: 0
				}
			}
		},
		methods: {
			moment,
			loadList() {
				this.loading = true;
				this.$api.admin.loginLogs({
					page: this.pagination.page,
					size: this.pagination.size,
					mobile: this.mobile || undefined,
					status: this.status === '' ? undefined : this.status
				}).then(({data}) => {
					this.dataList = data.records || [];
					this.pagination.total = Number(data.total || 0);
				}).finally(() => this.loading = false);
			},
			doSearch() {
				this.pagination.page = 1;
				this.loadList();
			}
		},
		mounted() {
			this.loadList();
		}
	}
</script>
